import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { PaymentMeansComponent } from './payment-means/payment-means.component';
import { GenericEntryForm } from 'src/app/infrastructure/infrastructure-services/generics/genericentryform/generic-entry-form';
import { GenericAutoCompleteView } from 'src/app/infrastructure/infrastructure-services/generics/generic-autocomplete-view/generic-autocomplete-view';
import { GenericAttachmentUploadFunctions } from 'src/app/infrastructure/infrastructure-services/generics/generic-attachment-upload/generic-attachment-upload-functions';
import { GenericAttachmentUploadView } from 'src/app/infrastructure/infrastructure-services/generics/generic-attachment-upload/generic-attachment-upload-view';
import { HttpClient } from '@angular/common/http';
import { Attachments2_LinesModel, IIncomingPaymentModel, IIncomingPaymentModelSAP, IncomingPaymentModel, IncomingPaymentModelSAP, PaymentAccounts, PaymentAccountsSAP, PaymentInvoices, PaymentInvoicesSAP } from 'src/app/core/models/masters/incoming-payment.model';
import { GenericService } from 'src/app/infrastructure/infrastructure-services/services/base/generic-service';
import { DateAdapter } from '@angular/material/core';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseService } from 'src/app/infrastructure/infrastructure-services/services/base/base-service';
import { GenericCflViewComponent } from 'src/app/infrastructure/infrastructure-services/generics/generic-cfl-view/generic-cfl-view.component';
import { WrapperStandardFilter, WrapperStandardRequest } from 'src/app/infrastructure/infrastructure-services/common/models/wrapper.model';
import { enumErrorMessageText, enumFormModes, enumIncomingOutgoingPaymentDocumentType, enumIncomingOutgoingPaymentEntryForm } from 'src/app/infrastructure/infrastructure-services/common/common-enums';
import { lastValueFrom, map, Observable, startWith } from 'rxjs';
import { FormControl } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { GlobalProperties } from 'src/app/global/global-properties';
import { DatePipe } from '@angular/common';
import { mapper } from 'src/app/infrastructure/infrastructure-services/common/mapper';
import { createMap } from '@automapper/core';
import { PaymentCreditCards, PaymentCreditCardsSAP } from 'src/app/core/models/masters/payment-means.model';
import { JournalentryEntryFormComponent } from '../../banking/journalentry-entry-form/journalentry-entry-form.component';
import { CommentDialogComponent } from '../../approval-process/comment-dialog/comment-dialog.component';
import { SecurityService } from 'src/app/login-layout/Service/security.service';

interface Branch {
  branchName: string;
  bplid: number;
}

interface Series {
  code: number,
  name: string,
  bplid: number
}
@Component({
  selector: 'app-incoming-payment',
  templateUrl: './incoming-payment.component.html',
  styleUrls: ['./incoming-payment.component.css'],
  providers: [DatePipe]
})
export class IncomingPaymentComponent extends GenericEntryForm<IIncomingPaymentModel, IIncomingPaymentModelSAP> {
  displayedColumns: string[] = [];
  displayedColumns2: string[] = [];
  dataSource: any[] = [];
  selectedFile: any[] = [];
  selectedAttacment: any[] = [];
  ArrayofSelectedFile = new Array<string>();
  abc = "a";
  auser: any;

  isLinear = false;
  Allitem: any[] = [];
  branch: any;
  bplid: any;
  name: any;
  series: any;
  myControlBranch = new FormControl<string | Branch>({ value: '', disabled: this.getFormDisable });
  OptionBranch: Branch[] = []
  filteredOptionsBranch!: Observable<Branch[]>;
  myControlSeries = new FormControl<string | Series>('');
  OptionSeries: Series[] = []
  filteredOptionsSeries!: Observable<Series[]>;

  apiString = "";
  navFrom!: string;
  draftEntry: string = '';
  objectType: string = '';
  selectedCode: number = 0;
  cutomerOrVendorDisabled: boolean = false;
  genAutoComplete = new GenericAutoCompleteView<IIncomingPaymentModel>(this.agenericRepositoryForCfl, this.routerForCfl);
  genAttachList = new GenericAttachmentUploadFunctions<IIncomingPaymentModel>(this.http);
  genAttachUpload = new GenericAttachmentUploadView<IIncomingPaymentModel>(this.http);

  canAdd: boolean = true;
  canEdit: boolean = true;
  canView: boolean = true;
  isActiveMenu: boolean = true;

  checkMenuPermissions() {
    let securityService = new SecurityService();
    let permissions = securityService.getMenuPermissions(this.getFormSubTitle);

    this.canAdd = permissions.canAdd;
    this.canEdit = permissions.canEdit;
    this.canView = permissions.canView;
    this.isActiveMenu = permissions.isActive;
  }

  constructor(private http: HttpClient, agenericRepository: GenericService<IIncomingPaymentModel>, private activatedRoute: ActivatedRoute, router: Router,
    public matDialogforCfl: MatDialog, dialog: MatDialog, public matDialogRefForCfl: MatDialogRef<GenericCflViewComponent<IIncomingPaymentModel>>,
    @Inject(MAT_DIALOG_DATA) private data: any, private dbService: NgxIndexedDBService, private dateAdapter: DateAdapter<Date>,
    public agenericRepositoryForCfl: GenericService<IIncomingPaymentModel>, public routerForCfl: Router, public snackbarService: BaseService<any>, private activated: ActivatedRoute, private datePipe: DatePipe,
    public generic: GenericService<any>) {
    super(agenericRepository, router, dialog);
    this.setMenuCode = "M311";

    localStorage.removeItem('Absolute');

    this.navFrom = localStorage.getItem('navFrom')!;
    localStorage.removeItem('navFrom');

    this.activated.url.subscribe(data => {
      if (this.navFrom == 'PendingApproval' || this.navFrom == 'PendingApprovalBulk') {
        this.draftEntry = data[1].path;
        this.objectType = localStorage.getItem('objectType')!;
        localStorage.removeItem('objectType');
        if (this.navFrom == 'PendingApproval') {
          this.setListViewFormRouteTo = '/home/approval-process/pendingApprovalIndv/';
        } else if (this.navFrom == 'PendingApprovalBulk') {
          this.setListViewFormRouteTo = '/home/approval-process/pendingApprovalBulk/';
        }
        let incomingpayment = new IncomingPaymentModel();
        this.setEntryFormDataSource = incomingpayment;

        this.setDraftsData(this.objectType);
      } else {
        if (data[0].path == enumIncomingOutgoingPaymentEntryForm.IncomingPaymentEntry) {
          this.apiString = "IncomingPayments/GetIncomingPaymentsService";
          this.setListViewFormRouteTo = "/home/sales/incomingPaymentListView/";
        }
        else if (data[0].path == enumIncomingOutgoingPaymentEntryForm.OutgoingPaymentEntry) {
          this.apiString = "OutgoingPayments/GetOutgoingPaymentsService";
          this.setListViewFormRouteTo = "/home/sales/outgoingPaymentListView/";
        }
        this.setObjectType = this.activated.snapshot.data['ObjType'];
        if (this.getObjectType == enumIncomingOutgoingPaymentDocumentType.IncomingPayment) {
          // this.setURLForFormModeNew = "GoodsIssue/NewGoodsIssueService";
          this.setFormSubTitle = 'Incoming Payment'
          //  this.setURLForFormModeNew = "IncomingPayments/NewIncomingPaymentsService";
          this.setURLForFormModeAddSap = "IncomingPayments";
          this.setURLForFormModeUpdateSap = `IncomingPayments(${this.activatedRoute.snapshot.params['id']})`;
          this.setURLForFormModeEdit = "IncomingPayments/GetIncomingPaymentsService";

        }
        else if (this.getObjectType == enumIncomingOutgoingPaymentDocumentType.OutgoingPayment) {
          //   this.setURLForFormModeNew = "GoodsReceipt/NewGoodsReceiptService";
          this.setFormSubTitle = 'Outgoing Payment'
          //this.setURLForFormModeNew = "OutgoingPayments/NewOutgoingPaymentsService";
          this.setURLForFormModeAddSap = "VendorPayments";
          this.setURLForFormModeUpdateSap = `VendorPayments(${this.activatedRoute.snapshot.params['id']})`;
          this.setURLForFormModeEdit = "OutgoingPayments/GetOutgoingPaymentsService";
        }

        // this.setURLForFormModeEdit = "IncomingPayments/GetIncomingPaymentsService";
        // this.setURLForFormModeAddSap = "IncomingPayments";
        // this.setURLForFormModeUpdateSap = `IncomingPayments(${this.activatedRoute.snapshot.params['id']})`;

        let incomingpayment = new IncomingPaymentModel();
        let incomingpaymentSap = new IncomingPaymentModelSAP();
        incomingpayment.docEntry = this.activatedRoute.snapshot.params['id'];
        this.setEntryFormDataSource = incomingpayment;
        this.setEntryFormDataSourceSAP = incomingpaymentSap;

        // let inventoryPostingLines = new InventoryPostingLineModel();
        // inventoryposting.inventoryPostingLines.push(inventoryPostingLines);
        localStorage.removeItem('Absolute');

        if (incomingpayment.docEntry > 0) {
          this.setRequestDataForFormModeEdit = incomingpayment.docEntry;
          this.setFormMode = enumFormModes.ModeEdit;
          this.setFormDisable = true;
        }
        else {
          this.setFormMode = enumFormModes.ModeNew;

        }
        this.PopulateEntryForm_V2()
        this.displayedColumns = ["select", "branch", "documentNo", "customerRefNo", "documentType", "documentDate", "dueDate", "overdueDays",
          "total", "balDue", "cashDiscount", "discountAmount", "totalPayment", "docRemarks"];
        this.displayedColumns2 = ["account", "docRemarks", "amount", "location", "branchName", "deleteRow"]

        this.getEntryFormDataSource.isViewMode = false;
      }
      this.checkMenuPermissions();
    });

    let roleType = sessionStorage.getItem('roleType');
    if ((roleType == 'Vendor') && this.getFormMode == enumFormModes.ModeNew && (this.getFormSubTitle == 'Outgoing Payment')) {
      this.cutomerOrVendorDisabled = true;
      let currentUser: any = sessionStorage.getItem('currentUser');
      let user = JSON.parse(currentUser);

      this.getEmpInfo(user.UserName)

    }

  }
  async PopulateEntryForm_V2() {
    debugger;
    if (this.getFormMode != 0) {
      await this.PopulateEntryForm();
      this.getEntryFormDataSource.billToCode = this.getEntryFormDataSource.payToCode;
      console.log("doctype", this.getEntryFormDataSource.docType)
    }

    await this.genAttachUpload.onAttachmentGetFiles(this.getEntryFormDataSource.attachmentEntry);
    this.getEntryFormDataSource.Attachments2_Lines = this.genAttachUpload.getAttactmentListData;
    this.getEntryFormDataSource?.paymentAccounts?.forEach(i => { i.isSelected = true; });
    this.getEntryFormDataSource?.paymentInvoices?.forEach(i => {
      i.isSelected = true;
      i.docDate = this.datePipe.transform(i.docDate, 'dd-MM-yy');
      i.dueDate = this.datePipe.transform(i.dueDate, "dd-MM-yy");
    });

    if (this.getFormMode == 0) {
      this.getEntryFormDataSource.docDate = new Date();
      this.getEntryFormDataSource.taxDate = new Date();
      this.getEntryFormDataSource.docDueDate = new Date();
      this.getEntryFormDataSource.bplid = Number(localStorage.getItem("BranchId"));
      this.getEntryFormDataSource.branchName = String(localStorage.getItem("BranchName"));
    }
  }

  async setDraftsData(objType: any) {
    await this.getCodeOfApprovalData();

    if (objType == '46') {
      this.setFormSubTitle = 'Outgoing Payment';
    } else if (objType == '24') {
      this.setFormSubTitle = 'Incoming Payment';
    }

    //call drafts api
    this.generic
      .GetAPIForSAP(
        GlobalProperties.getApiUrlSap + `Drafts(${this.draftEntry})`
      )
      .then(async (res: any) => {
        if (res != null) {
          // Convert the PascalCase response to camelCase
          const camelCasedData = this.convertPascalToCamelCase(res);
          console.log(camelCasedData);
          this.setEntryFormDataSource = camelCasedData;

          console.log('getEntryFormDataSource......', this.getEntryFormDataSource);
          this.getEntryFormDataSource.branchName = res.BPLName;
          this.getEntryFormDataSource.remarks = res.Comments;
          this.getEntryFormDataSource.journalRemarks = res.JournalMemo;

          this.getAttachmentData();
          this.getOtherDetails(res);
        }
      });
  }

  async getAttachmentData() {
    await this.genAttachUpload.onAttachmentGetFiles(
      this.getEntryFormDataSource.attachmentEntry
    );
    this.getEntryFormDataSource.Attachments2_Lines =
      this.genAttachUpload.getAttactmentListData;
  }
  async getOtherDetails(item: any) {
    this.activated.url.subscribe(async (data) => {
      //series
      var body = {
        SeriesParams: { Series: item.Series },
      };
      await this.generic
        .PostAPIForSAP(
          GlobalProperties.getApiUrlSap + `SeriesService_GetSeries`,
          body
        )
        .then(async (info: any) => {
          this.getEntryFormDataSource.seriesName = info.Name;
        });

      // get contact person name
      var names: any[] = [];
      if (item.CardCode != "" && item.CardCode != null && item.CardCode != undefined) {
        await this.generic
          .GetAPIForSAP(
            GlobalProperties.getApiUrlSap +
            `BusinessPartners('${item.CardCode}')?$select=ContactEmployees`
          )
          .then(async (info: any) => {
            if (info && info.ContactEmployees) {
              info.ContactEmployees.map((persons: any) => {
                if (persons.InternalCode == item.ContactPersonCode) {
                  names.push(persons.Name);
                  return;
                }
                this.getEntryFormDataSource.contactPersonName = names[0];
              });
            }
          });
      }
    });
  }
  convertPascalToCamelCase(obj: any): any {
    if (Array.isArray(obj)) {
      return obj.map((item) => this.convertPascalToCamelCase(item)); // Recursively convert for arrays
    } else if (obj !== null && typeof obj === 'object') {
      const result: any = {};
      Object.keys(obj).forEach((key) => {
        if (key === 'Attachments2_Lines') {
          // Keep the `Attachments2_Lines` field as is
          result[key] = obj[key];
        } else {
          // Convert PascalCase to camelCase for other fields
          const camelKey = key.charAt(0).toLowerCase() + key.slice(1);
          result[camelKey] = this.convertPascalToCamelCase(obj[key]); // Recursively apply for nested objects
        }
      });
      return result;
    }
    return obj; // If the value is not an object or array, return it as is
  }

  // formatDate(row: any) {
  //   return this.datePipe.transform(row.docDate, 'dd-MM-yy');
  // }
  async ngOnInit() {
    if (this.getFormMode == 0) {
      this.btnText = 'Language.AddText';
    }

    this.myControlBranch = new FormControl<string | Branch>({ value: String(localStorage.getItem("BranchName")), disabled: this.getFormDisable });
    this.myControlSeries = new FormControl<string | Series>({ value: '', disabled: this.getFormDisable });

    await this.getIntialAPIListForBranch();
    await this.getIntialAPIListForSeries();

    this.filteredOptionsBranch = this.myControlBranch.valueChanges.pipe(
      startWith(''),
      map(value => {
        const name = typeof value === 'string' ? value : value?.branchName;
        return name ? this._filterBranch(name as string) : this.OptionBranch.slice();
      }),
    );
    this.filteredOptionsSeries = this.myControlSeries.valueChanges.pipe(
      startWith(''),
      map(value => {
        const name = typeof value === 'string' ? value : value?.name;
        return name ? this._filterSeries(name as string) : this.OptionSeries.slice();
      }),
    );
    if (this.getFormMode === enumFormModes.ModeNew && this.getFormSubTitle == "Outgoing Payment") {
      this.getEntryFormDataSource.docType = "S";
    }

    if (this.getFormMode === enumFormModes.ModeNew && this.getFormSubTitle == "Incoming Payment") {
      this.getEntryFormDataSource.docType = "C";
    }

    if (this.getFormMode === enumFormModes.ModeNew) {
      this.getEntryFormDataSource.bplid = Number(localStorage.getItem("BranchId"));
      this.getEntryFormDataSource.branchName = String(localStorage.getItem("BranchName"));
      this.OnOptionSelectedBranch({ bplid: this.getEntryFormDataSource.bplid, branchName: this.getEntryFormDataSource.branchName });
    }
  }
  onchangeSumPaid(index: number) {
    this.getEntryFormDataSource.paymentAccounts[index].grossAmount = this.getEntryFormDataSource.paymentAccounts[index].sumPaid.toString();

    this.getEntryFormDataSource.docTotal = this.getEntryFormDataSource.paymentAccounts.reduce((sum, item) => sum + (item.sumPaid), 0);


  }
  async getIntialAPIListForBranch() {
    this.genAutoComplete.setACDataSourceURL = 'Branch/GetBranchListService';
    this.genAutoComplete.setACSortColumn = "bplid";

    let filter: WrapperStandardFilter = new WrapperStandardFilter();
    filter.Key = 'disabled';
    filter.OperatorType = 'contains';
    filter.Value = 'N'

    this.genAutoComplete._filterArray = [];
    this.genAutoComplete.setFilterArray = filter;

    let result = await this.genAutoComplete.onClickOptionsList();

    result.forEach((element: any) => {
      this.OptionBranch.push({ 'branchName': element.branchName, 'bplid': element.bplid });
    })
  }
  private _filterBranch(name: string): Branch[] {
    const filterValue = name.toLowerCase();
    return this.OptionBranch.filter(option => option.branchName.toLowerCase().includes(filterValue));
  }

  private _filterSeries(name: string): Series[] {
    const filterValue = name.toLowerCase();
    return this.OptionSeries.filter(option => option.name.toLowerCase().includes(filterValue));
  }



  async getIntialAPIListForSeries() {
    this.genAutoComplete.setACDataSourceURL = 'DocumentNumberingSetup/GetDocumentNumberingSetupListService';
    this.genAutoComplete.setACSortColumn = "series";

    let filters: Array<WrapperStandardFilter> = [
      { Key: 'disabled', Value: 'N', OperatorType: 'contains' },
      { Key: 'locked', Value: 'N', OperatorType: 'contains' }
    ];

    if (this.getFormSubTitle == "Incoming Payment") {
      filters.push({ Key: 'document', Value: '24', OperatorType: null });
    } else if (this.getFormSubTitle == "Outgoing Payment") {
      filters.push({ Key: 'document', Value: '46', OperatorType: null });
    }

    this.genAutoComplete._filterArray = [];
    this.genAutoComplete.getRequestData.RequestData = filters;

    let result = await this.genAutoComplete.onClickOptionsList();

    this.OptionSeries = [];

    result.forEach((element: any) => {
      this.OptionSeries.push({
        name: element.name,
        code: element.series,
        bplid: element.bplid
      });
    });
    console.log(result);
  }





  OnOptionSelectedBranch(option: Branch) {
    // this.btnText = 'Language.UpdateText';
    this.branch = option;
    this.bplid = option ? option.bplid : null;
    this.getEntryFormDataSource.bplid = this.bplid;
    this.getEntryFormDataSource.branchName = option.branchName;
    if (option.bplid == null) {
      this.getEntryFormDataSource.branchName = "";
      this.getEntryFormDataSource.bplid = 0;
      return;
    }

    this.getInvoice();
  }
  OnOptionSelectedSeries(option: Series) {
    // if (this.btnText == 'Language.OkText') {
    //   this.btnText = 'Language.UpdateText';
    // }
    this.name = option;
    this.series = option ? option.code : null;
    this.getEntryFormDataSource.series = option.code;
    this.getEntryFormDataSource.seriesName = option.name;
    if (option.bplid == null) {
      this.getEntryFormDataSource.seriesName = "";
      this.getEntryFormDataSource.series = 0;
      return;
    }
  }
  addRow() {
    if ((this.getFormMode == 0 && !this.canAdd) || (this.getFormMode == 1 && !this.canEdit)) return;
    // if (this.btnText == 'Language.OkText') {
    //   this.btnText = 'Language.UpdateText';
    // }
    //   let lineItem = new InventoryPostingLineModel();
    //   this.getEntryFormDataSource.inventoryPostingLines.push(lineItem);
    //   this.getEntryFormDataSource.inventoryPostingLines = [...this.getEntryFormDataSource.inventoryPostingLines];
  }
  deleteRow(index: number) {
    if ((this.getFormMode == 0 && !this.canAdd) || (this.getFormMode == 1 && !this.canEdit)) return;
    // if (this.btnText == 'Language.OkText') {
    //   this.btnText = 'Language.UpdateText';
    // }
    //   this.getEntryFormDataSource.inventoryPostingLines.splice(index, 1);
    //   this.getEntryFormDataSource.inventoryPostingLines = [...this.getEntryFormDataSource.inventoryPostingLines];
  }
  addRow2() {
    if ((this.getFormMode == 0 && !this.canAdd) || (this.getFormMode == 1 && !this.canEdit)) return;
    if (this.btnText == 'Language.OkText') {
      this.btnText = 'Language.UpdateText';
    }
    let lineItem = new PaymentAccounts();
    // this.getEntryFormDataSource.inventoryPostingLines.push(lineItem);
    this.getEntryFormDataSource.paymentAccounts = [...this.getEntryFormDataSource.paymentAccounts, lineItem];
  }
  deleteRow2(index: number) {
    if ((this.getFormMode == 0 && !this.canAdd) || (this.getFormMode == 1 && !this.canEdit)) return;
    if (this.btnText == 'Language.OkText') {
      this.btnText = 'Language.UpdateText';
    }
    this.getEntryFormDataSource.paymentAccounts.splice(index, 1);
    // this.getEntryFormDataSource.inventoryPostingLines = [...this.getEntryFormDataSource.inventoryPostingLines];
  }
  onValidate(): boolean {
    let lreturn: boolean = true;
    let value = [];
    let data: any = this.getEntryFormDataSource;

    (data.docDate == undefined || data.docDate == null || data.docDate == "") ? value.push(enumErrorMessageText.postingDateStatus) : null;
    (data.docDueDate == undefined || data.docDueDate == null || data.docDueDate == "") ? value.push(enumErrorMessageText.DueDateEmptyStatus) : null;
    (data.taxDate == undefined || data.taxDate == null || data.taxDate == "") ? value.push(enumErrorMessageText.TaxDateEmptyStatus) : null;
    (data.branchName == undefined || data.branchName == null || data.branchName == "") ? value.push(enumErrorMessageText.BranchNameEmptyStatus) : null;

    (data.seriesName == undefined || data.seriesName == null || data.seriesName == "") ? value.push(enumErrorMessageText.SeriesEmptyStatus) : null;
    // if (this.getEntryFormDataSource.docType == 'C' || this.getEntryFormDataSource.docType == 'S') {
    //   (data.cardCode == undefined || data.cardCode == null || data.billToCode == "") ? value.push(enumErrorMessageText.AddressEmptyStatus) : null;


    // }

    // data.postingDate == undefined || data.postingDate== null || data.postingDate==""? value.push(enumErrorMessageText.branchNameStatus) : null;

    //   data.seriesName.length == 0 ? value.push(enumErrorMessageText.seriesNameStatus) : null;

    this.showValidationArr = value
    if (this.showValidationArr.length != 0) {
      lreturn = false
    }
    return lreturn
  }
  journalEntry() {
    this.dialog.open(JournalentryEntryFormComponent, { data: { id: this.getEntryFormDataSource.transactionNo } })
  }

  openDialog1(): void {
    let isViewOnly = ((this.getFormMode == 0 && !this.canAdd) || (this.getFormMode == 1 && !this.canEdit));
    if (this.getFormDisable || isViewOnly) {
      this.getEntryFormDataSource.isViewMode = true;
    }
    let isDisable = this.getFormDisable || this.getFormMode == 1 || isViewOnly;
    this.dialog.open(PaymentMeansComponent, { data: { data: this.getEntryFormDataSource, disable: isDisable } }).afterClosed().
      subscribe(res => {
        // this.getEntryFormDataSource=res.value;
        this.getEntryFormDataSource.paymentCreditCards = res.value.paymentCreditCards[0].creditCard == null ||
          res.value.paymentCreditCards[0].creditCard == undefined || res.value.paymentCreditCards[0].creditCard == "" ? [] : res.value.paymentCreditCards;
        this.getEntryFormDataSource.paymentChecks = res.value.paymentChecks;
        this.getEntryFormDataSource.transferSum = res.value.transferSum;
        this.getEntryFormDataSource.creditSum = res.value.creditSum;
        this.getEntryFormDataSource.checkSum = res.value.checkSum;
        this.getEntryFormDataSource.cashSum = res.value.cashSum;
        this.getEntryFormDataSource.transferAccount = res.value.transferAccount;
        this.getEntryFormDataSource.transferAccountName = res.value.transferAccountName;
        this.getEntryFormDataSource.cashAccount = res.value.cashAccount;
        this.getEntryFormDataSource.cashAccountName = res.value.cashAccountName;
        this.getEntryFormDataSource.transferDate = res.value.transferDate;
        this.getEntryFormDataSource.transferReference = res.value.transferReference;
        //  this.getEntryFormDataSource.docTotal=res.value.totalPayment;
        this.getEntryFormDataSource.isViewMode = res.value.isViewMode;


      });
  }
  getInvoice() {
    let api = "";
    if (this.getFormSubTitle == "Incoming Payment") {
      api = "IncomingPayments/NewIncomingPaymentsService";
    }
    else if (this.getFormSubTitle == "Outgoing Payment") {
      api = "OutgoingPayments/NewOutgoingPaymentsService"
    }
    if (this.getEntryFormDataSource.cardCode && this.getEntryFormDataSource.bplid) {
      let body = {
        "userId": 0,
        "userGuid": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        "companyCode": GlobalProperties._compnayCode,
        "requestData": {
          "cardCode": this.getEntryFormDataSource.cardCode,

          "bplid": this.getEntryFormDataSource.bplid
        },
        "pageRecordCount": 0,
        "pageSize": 0,
        "isAcending": true,
        "sortColumn": "docNum"
      }

      this.agenericRepositoryForCfl.PostAPI(GlobalProperties.getApiUrl + api, body).subscribe(res => {

        console.log(res);

        let paymentInvoices: PaymentInvoices[] = [];
        res.responseData.forEach((row: any) => {

          let paymentInvoice = new PaymentInvoices();
          paymentInvoice.docNum = row.maxDocNum;
          paymentInvoice.docTypeName = row.maxDocType;
          paymentInvoice.docType = row.maxDocType;
          if (row.maxDocType == "A/R Down Payment") {
            paymentInvoice.invoiceType = "it_DownPayment";
          }
          if (row.maxDocType == "A/P Down Payment") {
            paymentInvoice.invoiceType = "it_PurchaseDownPayment";
          }
          if (row.maxDocType == "A/R Invoices") {
            paymentInvoice.invoiceType = "it_Invoice";
          }
          if (row.maxDocType == "A/P Invoices") {
            paymentInvoice.invoiceType = "it_PurchaseInvoice";
          }
          if (row.maxDocType == "Journal Entries") {
            paymentInvoice.invoiceType = "it_JournalEntry";
          }
          if (row.maxDocType == "A/R Credit Memos") {
            paymentInvoice.invoiceType = "it_CredItnote";
          }
          if (row.maxDocType == "A/P Credit Memos") {
            paymentInvoice.invoiceType = "it_PurchaseCreditNote";
          }

          if (row.maxDocType == "Incoming Payments") {

            paymentInvoice.invoiceType = "it_Receipt";
          }
          if (row.maxDocType == "Outgoing Payments") {
            paymentInvoice.invoiceType = "it_PaymentAdvice";
          }
          paymentInvoice.docDate = this.datePipe.transform(row.maxDocDate, "dd-MM-yy");
          paymentInvoice.dueDate = this.datePipe.transform(row.maxDueDate, "dd-MM-yy");
          paymentInvoice.cardCode = row.maxCardCode;
          paymentInvoice.numAtCard = row.maxNumAtCard;
          paymentInvoice.docTotal = row.maxInsTotal;
          paymentInvoice.dueAmount = row.balanceDue;
          paymentInvoice.sumApplied = row.balanceDue;
          paymentInvoice.docCurrency = row.maxDocCur;
          paymentInvoice.docEntry = row.docEntry;
          paymentInvoice.overDueDays = row.overDueDays;
          paymentInvoice.branchName = this.getEntryFormDataSource.branchName;
          paymentInvoice.remarks = row.maxComments;
          paymentInvoices.push(paymentInvoice);
          paymentInvoice.docLine = row.lineNum;

        })
        this.getEntryFormDataSource.paymentInvoices = paymentInvoices;
      });
    }

  }
  onDocTypeChange() {
    this.getEntryFormDataSource.cardCode = "";
    this.getEntryFormDataSource.cardName = "";
    this.getEntryFormDataSource.address = "";
    this.getEntryFormDataSource.billToCode = "";
    this.getEntryFormDataSource.contactPersonName = "";
    this.getEntryFormDataSource.isViewMode = false;
  }
  calculateOverdueDays(dueDate: Date): number {
    if (!dueDate) return 0; // Handle empty values

    const due = new Date(dueDate); // Convert dueDate to Date object
    const today = new Date(); // Get today's date

    // Calculate difference in milliseconds
    const difference = today.getTime() - due.getTime();

    // Convert milliseconds to days
    const overdueDays = Math.floor(difference / (1000 * 60 * 60 * 24));

    return overdueDays > 0 ? overdueDays : 0; // Return overdue days, or 0 if not overdue
  }
  calculateDiscount(index: number) {

    this.getEntryFormDataSource.paymentInvoices[index].totalDiscount = (this.getEntryFormDataSource.paymentInvoices[index].sumApplied *
      this.getEntryFormDataSource.paymentInvoices[index].discountPercent) / 100;
    this.getEntryFormDataSource.paymentInvoices[index].sumApplied -= this.getEntryFormDataSource.paymentInvoices[index].totalDiscount;

  }
  changediscount(index: number) {
    this.getEntryFormDataSource.paymentInvoices[index].discountPercent = 0;
    this.getEntryFormDataSource.paymentInvoices[index].totalDiscount = 0;
    this.getEntryFormDataSource.docTotal = this.getEntryFormDataSource.paymentInvoices.filter((item: any) => { return item.isSelected }).reduce((sum, item) => sum + item.sumApplied, 0);
    this.getEntryFormDataSource.paymentInvoices[index].dueAmount =
      this.getEntryFormDataSource.paymentInvoices[index].docTotal -
      this.getEntryFormDataSource.paymentInvoices[index].sumApplied;

  }
  onOpenDropDown(value: any, id: number) {
    if ((this.getFormMode == 0 && !this.canAdd) || (this.getFormMode == 1 && !this.canEdit)) return;

    let filter: WrapperStandardFilter = new WrapperStandardFilter();
    let genCFL = new GenericCflViewComponent<IIncomingPaymentModel>(this.agenericRepositoryForCfl, this.routerForCfl, this.matDialogforCfl, this.matDialogRefForCfl, this.data, this.dbService);

    if (value == 'BPCode') {

      if (this.getEntryFormDataSource.docType == "C") {
        genCFL.setCflTitle = "Customer Details";
      }
      else if (this.getEntryFormDataSource.docType == "S") {
        genCFL.setCflTitle = "Vendor Details";
      }
      genCFL.setCflViewDataSourceURL = 'BusinessPartner/GetBusinessPartnerListService';
      genCFL.setCflDisplayedColumnsNamesList = ['cardCode', 'cardName', 'cardType'];
      genCFL.setCflSelectedData = this.getEntryFormDataSource.cardCode;
      genCFL.setSortColumn = "cardCode";
      filter.Key = 'cardType';
      filter.OperatorType = "contains";
      filter.Value = this.getEntryFormDataSource.docType;
      genCFL.setCflFilterArray = filter;
    }

    if (value == 'BPLName') {
      genCFL.setCflTitle = "Branch Details";
      genCFL.setCflViewDataSourceURL = 'Branch/GetBranchListService';
      genCFL.setCflDisplayedColumnsNamesList = ['branchName'];
      genCFL.setCflSelectedData = this.getEntryFormDataSource.branchName;
      genCFL.setSortColumn = "branchName";
      filter.Key = 'disabled';
      filter.OperatorType = 'contains';
      filter.Value = 'N'
      genCFL.setCflFilterArray = filter;
    }
    if (value == 'branch') {
      genCFL.setCflTitle = "Branch Details";
      genCFL.setCflViewDataSourceURL = 'Branch/GetBranchListService';
      genCFL.setCflDisplayedColumnsNamesList = ['branchName'];
      genCFL.setCflSelectedData = this.getEntryFormDataSource.branchName;
      genCFL.setSortColumn = "branchName";
      filter.Key = 'disabled';
      filter.OperatorType = 'contains';
      filter.Value = 'N'
      genCFL.setCflFilterArray = filter;
    }
    if (value == 'Series') {
      genCFL.setCflTitle = "Series Detalis";
      genCFL.setCflViewDataSourceURL = 'DocumentNumberingSetup/GetDocumentNumberingSetupListService';
      genCFL.setCflDisplayedColumnsNamesList = ['series', 'name'];
      genCFL.setCflSelectedData = this.getEntryFormDataSource.seriesName
      genCFL.setSortColumn = "name";
      filter.Key = 'document';
      filter.OperatorType = null;
      if (this.getFormSubTitle == "Incoming Payment") {
        filter.Value = '24';
      } else if (this.getFormSubTitle == "Outgoing Payment") {
        filter.Value = '46';
      }

      genCFL.setCflFilterArray = filter;
      var filter1: WrapperStandardFilter = new WrapperStandardFilter();
      filter1.Key = 'locked';
      filter1.OperatorType = "contains";
      filter1.Value = 'N';
      genCFL.setCflFilterArray = filter1;
    }
    if (value == 'BillTo') {
      genCFL.setCflTitle = "Bill To Details";
      genCFL.setCflViewDataSourceURL = 'BusinessPartner/GetBillToBPAddressListService';
      genCFL.setCflDisplayedColumnsNamesList = ['cardCode', 'addressName'];
      genCFL.setCflSelectedData = this.getEntryFormDataSource.billToCode;
      genCFL.setSortColumn = "cardCode";
      // filter.Key = 'cardCode';
      // filter.Value = this.getEntryFormDataSource.cardCode;
      // filter.OperatorType = "contains";
      // genCFL.setCflFilterArray = filter;
      genCFL.setCFLRequestDataWithCode = this.getEntryFormDataSource.cardCode;
    }
    if (value == 'ContactPerson') {
      genCFL.setCflTitle = "Contact Person Details";
      genCFL.setCflViewDataSourceURL = 'ContactPerson/GetContactPersonListService';
      genCFL.setCflDisplayedColumnsNamesList = ['contactPersonCode', 'cardCode', 'name'];
      genCFL.setCflSelectedData = this.getEntryFormDataSource.billToCode;
      genCFL.setSortColumn = "cardCode";
      filter.Key = 'cardCode';
      filter.Value = this.getEntryFormDataSource.cardCode;
      filter.OperatorType = "contains";
      genCFL.setCflFilterArray = filter;
      //genCFL.setCFLRequestDataWithCode = this.getEntryFormDataSource.contact;
    }
    if (value == 3) {
      genCFL.setCflTitle = "Chart Of Account";
      genCFL.setCflViewDataSourceURL = 'ChartOfAccounts/GetChartOfAccountsListService';
      genCFL.setCflDisplayedColumnsNamesList = ['code', 'name'];
      genCFL.setCflSelectedData = this.getEntryFormDataSource.paymentAccounts[id].accountCode;
      genCFL.setSortColumn = "code";

    }
    if (value == "offsetaccount") {
      genCFL.setCflTitle = "Chart Of Account";
      genCFL.setCflViewDataSourceURL = 'ChartOfAccounts/GetChartOfAccountsListService';
      genCFL.setCflDisplayedColumnsNamesList = ['code', 'name'];
      genCFL.setCflSelectedData = this.getEntryFormDataSource.controlAccount;
      genCFL.setSortColumn = "code";

    }
    if (value == 'location') {
      genCFL.setCflTitle = "Location";
      genCFL.setCflViewDataSourceURL = 'Location/GetLocationListService';
      genCFL.setCflDisplayedColumnsNamesList = ['name', 'city'];
      genCFL.setCflSelectedData = this.getEntryFormDataSource.paymentAccounts[id].locationCode;
      genCFL.setSortColumn = "name";
    }

    genCFL.openCFL(GenericCflViewComponent, {}).afterClosed().subscribe(async res => {
      if (res != undefined && res.event != undefined) {
        if (this.btnText == 'Language.OkText') {
          this.btnText = 'Language.UpdateText';
        }
        if (value == 'BPCode') {
          this.getEntryFormDataSource.cardCode = res.event.cardCode;
          this.getEntryFormDataSource.cardName = res.event.cardName;
          this.getEntryFormDataSource.billToCode = res.event.shipToDefault;
          this.getEntryFormDataSource.isViewMode = false;
          this.getEntryFormDataSource.docTotal = 0;
          const RequestBody = new WrapperStandardRequest();
          RequestBody.RequestData =
            res.event.cardCode
            ;
          RequestBody.SortColumn = "name";
          let response: any = await lastValueFrom(this.http.post(`${GlobalProperties.getApiUrl}BusinessPartner/GetBusinessPartnerService`, RequestBody, { withCredentials: true }));


          response.responseData.bpAddresses?.forEach((element: any) => {
            if (element.addressName == this.getEntryFormDataSource.billToCode) {
              let address = '';
              address = element.street + " " + element.city + " " + element.stateName;
              this.getEntryFormDataSource.address = address;
            }
          });


          //   this.getEntryFormDataSource.docType=res.event.cardType;
          this.getInvoice();
        }

        else if (value == 'BPLName') {
          this.getEntryFormDataSource.bplid = res.event.bplid;
          this.getEntryFormDataSource.branchName = res.event.branchName;

          this.getEntryFormDataSource.seriesName = this.OptionSeries.filter(i => { return i.bplid == res.event.bplid })[0] == undefined ? "" : this.OptionSeries.filter(i => { return i.bplid == res.event.bplid })[0].name;
          this.getEntryFormDataSource.series = this.OptionSeries.filter(i => { return i.bplid == res.event.bplid })[0] == undefined ? 0 : this.OptionSeries.filter(i => { return i.bplid == res.event.bplid })[0].code;

        }
        else if (value == 'Series') {
          this.getEntryFormDataSource.series = res.event.series;
          this.getEntryFormDataSource.seriesName = res.event.name;
        }
        else if (value == 'BillTo') {
          this.getEntryFormDataSource.billToCode = res.event.addressName;

          this.getEntryFormDataSource.payToCode = res.event.addressName;

          let address = '';
          address = res.event.street + " " + res.event.city + " " + res.event.stateName;
          this.getEntryFormDataSource.address = address;
        }
        else if (value == 'ContactPerson') {
          this.getEntryFormDataSource.contactPersonCode = res.event.contactPersonCode;
          this.getEntryFormDataSource.contactPersonName = res.event.name;

        }
        else if (value == 3) {
          this.getEntryFormDataSource.paymentAccounts[id].accountCode = res.event.code;
          this.getEntryFormDataSource.paymentAccounts[id].accountName = res.event.name;
        }
        else if (value == 'location') {

          this.getEntryFormDataSource.paymentAccounts[id].locationCode = res.event.code;
          this.getEntryFormDataSource.paymentAccounts[id].locationName = res.event.name;

        }
        else if (value == 'branch') {
          this.getEntryFormDataSource.paymentAccounts[id].branchName = res.event.branchName;
        }
        else if (value == "offsetaccount") {
          this.getEntryFormDataSource.controlAccount = res.event.code;
          this.getEntryFormDataSource.controlAccountName = res.event.name;
        }
      }




    });

  }
  onSave(aEvent: any) {

    if (this.btnText == 'Language.OkText') {
      this.routerForCfl.navigate([this.getListViewFormRouteTo]);
    }
    else {
      if (this.onValidate()) {
        if (this.getFormMode == enumFormModes.ModeEdit) {
          createMap(mapper, PaymentAccounts, PaymentAccountsSAP);
          createMap(mapper, PaymentInvoices, PaymentInvoicesSAP);
          createMap(mapper, PaymentCreditCards, PaymentCreditCardsSAP);
          this.getEntryFormDataSource.paymentInvoices = this.getEntryFormDataSource.paymentInvoices.filter((el => { return el.isSelected }));
          let dto = mapper.map(this.getEntryFormDataSource, IncomingPaymentModel, IncomingPaymentModelSAP);
          dto.AttachmentEntry = localStorage.getItem("Absolute");

          if (dto.Series === 0) {
            delete (dto as any).Series;
          }

          if (dto.CashAccount === "") {
            (dto as any).CashAccount = null;
          }
          if (dto.TransferAccount === "") {
            (dto as any).TransferAccount = null;
          }

          if (this.getFormMode == 1) {
            delete (dto as any).TransferReference;
            // delete (dto as any).TransferAccount;
            delete (dto as any).CashAccount;
            delete (dto as any).ControlAccount
          }


          // Removed InvoiceType filter to ensure selected invoices are included in the payload
          this.setEntryFormDataSourceSAP = dto;
          this.SaveEntryForm();
        }
        else if (this.getFormMode == enumFormModes.ModeNew && this.getEntryFormDataSource.isViewMode) {
          createMap(mapper, PaymentAccounts, PaymentAccountsSAP);
          createMap(mapper, PaymentInvoices, PaymentInvoicesSAP);
          createMap(mapper, PaymentCreditCards, PaymentCreditCardsSAP);
          this.getEntryFormDataSource.paymentInvoices = this.getEntryFormDataSource.paymentInvoices.filter((el => { return el.isSelected }));
          let dto = mapper.map(this.getEntryFormDataSource, IncomingPaymentModel, IncomingPaymentModelSAP);
          dto.AttachmentEntry = localStorage.getItem("Absolute");

          if (dto.Series === 0) {
            delete (dto as any).Series;
          }

          if (dto.PaymentInvoices && dto.PaymentInvoices.length > 0) {

            // Only send DocNum in Edit Mode
            dto.PaymentInvoices.forEach(inv => {
              delete (inv as any).DocNum;
            });
          }

          this.setEntryFormDataSourceSAP = dto;
          this.SaveEntryForm();
        }
      }
      else {
        this.openDialog();
      }
    }

  }


  onChangeCheckBox(event: MatCheckboxChange, row: any) {

    row.isSelected = event.checked;
    let sum = 0;
    this.getEntryFormDataSource.docTotal = this.getEntryFormDataSource.paymentInvoices.filter((item: any) => { return item.isSelected }).reduce((sum, item) => sum + (item.sumApplied), 0);
    console.log("doccur", row);
    this.getEntryFormDataSource.docCurrency = row.docCurrency;//  let checked = event.checked;
    // if (checked) {
    // this.getEntryFormDataSource
    //   this.arrMultupleSelectedData.push(element);
    // } else {
    //   this.isDone = false;
    //   delete element.isSelected
    //   let indx = this.arrMultupleSelectedData!.indexOf(element);
    //   if (indx >= 0) {
    //     this.arrMultupleSelectedData.splice(indx, 1);
    //   }
    //   element.isSelected = this.checked;
    // }
    // this.setCflSelectedData = this.arrMultupleSelectedData;

  }
  onSelectedFiles(event: any) {
    this.genAttachUpload.setSelectedFileList = event;
    this.selectedFile.push(...Array.from(event.target.files))
    for (let i = 0; i < this.selectedFile.length; i++) {
      var _files = new Attachments2_LinesModel();
      _files.FileName = event.target.files[i].name;
      _files.FileExtension = event.target.files[i].name.split(".")[event.target.files[i].name.split(".").length - 1];
      this.getEntryFormDataSource.Attachments2_Lines.push(_files);
    }
    this.genAttachUpload.onSelectedFiles();
  }
  onUpload() {
    if (this.validateFileSize()) {
      this.genAttachUpload.onUploadFiles(this.getEntryFormDataSource.attachmentEntry);
    } else {
      this.openDialog();
    }
  }

  validateFileSize() {
    const maxFileSize = 5 * 1024 * 1024; // 5 MB in bytes
    const files = this.selectedFile;
    let errors: string[] = [];

    if (files.length > 10) {
      errors.push('You can only upload a maximum of 10 files.');
    } else {
      files.forEach((el, i): any => {
        let file: any = files[i];
        if (file.size > maxFileSize) {
          errors.push(`File "${file.name}" exceeds the 5 MB size limit.`);
        }
      })
    }

    if (errors.length > 0) {
      this.showValidationArr = errors;
      return false;
    } else {
      return true;
    }
  }

  onAttachmentDelete(val: number) {
    this.selectedFile.splice(val, 1);
    this.getEntryFormDataSource.Attachments2_Lines.splice(val, 1);
    this.getEntryFormDataSource.Attachments2_Lines = [...this.getEntryFormDataSource.Attachments2_Lines];
    if (this.getEntryFormDataSource.attachmentEntry != null && this.getEntryFormDataSource.attachmentEntry != "" && this.getEntryFormDataSource.attachmentEntry != undefined) {
      this.genAttachUpload.onAttachmentDeleteFiles(this.getEntryFormDataSource.attachmentEntry, this.getEntryFormDataSource.Attachments2_Lines)
    }
  }

  viewImage(attachmentEntry: number, filePath = "") {
    window.open(`${GlobalProperties.getApiUrlSap}Attachments2(${attachmentEntry})/$value`, "_blank");
  }

  async getCodeOfApprovalData() {
    await this.agenericRepository
      .GetAPIForSAP(
        GlobalProperties.getApiUrlSap +
        `ApprovalRequests?$select=*&$inlinecount=allpages&$filter=Status eq 'arsPending' and DraftEntry eq ${this.draftEntry}`
      )
      .then(async (res: any) => {
        this.selectedCode = res.value?.[0]?.Code;
      });
  }
  openCommentDialog(action: string, code: any, status: any): void {
    const dialogRef = this.dialog.open(CommentDialogComponent);
    dialogRef.afterClosed().subscribe(result => {
      if (result != undefined) {
        console.log(`${action} Comment:`, result);
        // You can send the comment to the server or handle it as needed
        this.callApproveRejectSAPRequestAPI(code, status, result);
      }
    });
  }

  onApproveClick(event: Event) {
    this.openCommentDialog('Approve', this.selectedCode, 'ardApproved');
  }
  onRejectClick(event: Event) {
    this.openCommentDialog('Reject', this.selectedCode, 'ardNotApproved');
  }

  async callApproveRejectSAPRequestAPI(code: any, status: any, remarks: any) {
    let body = {
      ApprovalRequestDecisions: [
        {
          Status: status,
          Remarks: remarks, //"Approved - OK"
        },
      ],
    };
    await this.agenericRepository
      .PatchAPIForSAP(
        GlobalProperties.getApiUrlSap +
        `ApprovalRequests(${code})`,
        body
      )
      .then(async (info: any) => {
        if (status === 'ardApproved') {
          try {
            await this.agenericRepository.PostApiForSaveDocument(GlobalProperties.getApiUrlSap + `DraftsService_SaveDraftToDocument`, {
              "Document": {
                "DocEntry": this.draftEntry
              }
            });
          } catch (e) {
            console.error('Save Draft to Document failed', e);
          }
          this.snackbarService.showMessage(
            'Request has been approved successfully!',
            'X'
          );
        } else if (status === 'ardNotApproved') {
          this.snackbarService.showMessage(
            'Request has been rejected successfully!',
            'X'
          );
        }
        this.router.navigate([this.getListViewFormRouteTo]);
      });
  }



  getEmpInfo(cardCode: any) {
    let res: any = {};
    (async () => {
      this.getEntryFormDataSource.isViewMode = false;
      this.getEntryFormDataSource.docTotal = 0;
      const RequestBody = new WrapperStandardRequest();
      RequestBody.RequestData = cardCode;
      RequestBody.SortColumn = "name";
      let response: any = await lastValueFrom(this.http.post(`${GlobalProperties.getApiUrl}BusinessPartner/GetBusinessPartnerService`, RequestBody, { withCredentials: true }));
      res.event = response.responseData;
      this.getEntryFormDataSource.cardCode = res.event.cardCode;
      this.getEntryFormDataSource.cardName = res.event.cardName;
      this.getEntryFormDataSource.billToCode = res.event.shipToDefault;

      response.responseData.bpAddresses?.forEach((element: any) => {
        if (element.addressName == this.getEntryFormDataSource.billToCode) {
          let address = '';
          address = element.street + " " + element.city + " " + element.stateName;
          this.getEntryFormDataSource.address = address;
        }
      });



      //   this.getEntryFormDataSource.docType=res.event.cardType;
      this.getInvoice();
    })();
  }

}
